<ng-container *transloco="let t">
  @let sadms = (sadms$ | async) ?? [];
  @let entities = (sadmEntities$ | async) ?? [];
  @let patient = patient$ | async;

  @if (isDataLoaded$ | async) {
    @if (sadms.length > 0 || entities.length > 0) {
      <div class="flex items-center justify-between gap-2 max-md:flex-wrap">
        <pxc-filter-buttons />
        @if (sadms.length > 0 && patient) {
          <pxc-sadm-client-action-button
            data-testid="document-lesions"
            icon="@tui.table-2"
            [disabled]="!!patient.isArchived"
            [label]="t('Documenter les lésions')"
            [sadmClients]="sadms"
            (clientSelected)="openSadmGrid($event, patient)" />
        }
      </div>
      <pxc-sadm-entity-list [items]="entities" />
    } @else {
      <pxc-empty-state
        class="mx-auto my-3"
        data-testid="empty-state"
        icon="@tui.package"
        [description]="t('Contactez Pixacare pour activer le module Lésions.')"
        [title]="t('Aucune lésion disponible')" />
    }
  } @else {
    <pxc-loader class="mx-auto my-4 block" data-testid="loading">
      {{ t('Récupération des lésions en cours ...') }}
    </pxc-loader>
  }
</ng-container>
